import { CalendarCheck, PiggyBank, X } from "lucide-react";
import { Modal } from "../Modal";
import { track } from "../../lib/analytics";
import { mxn } from "../../lib/reservations";
import type { TripPage } from "../../types";

/**
 * Flow B — "¿Cómo quieres empezar a planear este viaje?" (7a). Two routes; a tap on a card or on its
 * button takes that route at once (the client found having to tick the radio first odd, 13 Oct
 * 2026). Nothing is created here: "Crear apartado" opens the same reservation modal as "Reservar",
 * and "Crear meta" opens the Wallet Libre "Tu sueño" form (B2, B3).
 */
export function PlanningModal({ trip, open, onOpenChange, minPerPassenger, onReserve, onGoal }: {
  trip: TripPage;
  open: boolean;
  onOpenChange(open: boolean): void;
  minPerPassenger: number;
  onReserve(): void;
  onGoal(): void;
}) {
  const duration = trip.durationDays ? ` · ${trip.durationDays} días` : "";

  // The card is a click target for the pointer; keyboard and screen-reader users get the button.
  const Option = ({ eyebrow, title, copy, cta, icon: Icon, action }: { eyebrow: string; title: string; copy: string; cta: string; icon: typeof PiggyBank; action(): void }) => (
    <div className="plan-option" onClick={action}>
      <span className="plan-icon"><Icon size={18} aria-hidden="true" /></span>
      <span className="plan-eyebrow">{eyebrow}</span>
      <h3>{title}</h3>
      <p>{copy}</p>
      <button type="button" className="primary-button solid full" onClick={(event) => { event.stopPropagation(); action(); }}>
        {cta}
      </button>
    </div>
  );

  return (
    <Modal open={open} onOpenChange={onOpenChange} label="¿Cómo quieres empezar a planear este viaje?">
      <div className="dialog-content wide plan-dialog">
        <button type="button" className="dialog-close" onClick={() => onOpenChange(false)} aria-label="Cerrar"><X size={20} aria-hidden="true" /></button>
        <span className="page-eyebrow">{trip.name}{duration}</span>
        <h2>¿Cómo quieres empezar a planear este viaje?</h2>
        <p>Elige una opción. Puedes cambiar de ruta más adelante.</p>
        <div className="plan-options">
          <Option
            icon={CalendarCheck} eyebrow="APARTAR ESTE VIAJE" title="Reservar ahora"
            copy={`Aparta con ${mxn(minPerPassenger).replace(".00", "")} por pasajero y paga el resto hasta un mes antes de viajar.`}
            cta="Crear apartado" action={() => { track("planning_route_selected", { route: "reservation_linked" }); onReserve(); }}
          />
          <Option
            icon={PiggyBank} eyebrow="AHORRAR SIN FECHA" title="Ahorrar para después"
            copy="Aporta a tu ritmo en tu Wallet Libre. Usa o retira tu dinero cuando quieras."
            cta="Crear meta" action={() => { track("planning_route_selected", { route: "wallet_goal" }); onGoal(); }}
          />
        </div>
        <p className="plan-fine">«Crear apartado» inicia la solicitud de reservación: el Apartado se ofrece una vez recibida tu solicitud y no se crea dinero apartado hasta que tú lo transfieras.</p>
      </div>
    </Modal>
  );
}
